export default {
  namespaced: true,
  state: {
    menuExpanded: false,
    loading: false
  },
  mutations: {
    TOGGLE_MENU(state) {
      state.menuExpanded = !state.menuExpanded;
    },
    SET_MENU(state, payload) {
      state.menuExpanded = payload;
    },

    SHOW_LOADING(state) {
      state.loading = true;
    },
    HIDE_LOADING(state) {
      state.loading = false;
    }
  },
  actions: {
    toggleMenu({ commit }) {
      commit('TOGGLE_MENU');
    },
    setMenu({ commit }, payload) {
      commit('SET_MENU', payload);
    },

    showLoading({ commit }) {
      commit('SHOW_LOADING');
    },
    hideLoading({ commit }) {
      commit('HIDE_LOADING');
    },
  },
  getters: {
    isMenuExpanded: (state) => state.menuExpanded,
    isShowingLoading: (state) => state.loading,
  },
};
